import React from "react";
import PropTypes from "prop-types";
import LineItem from "_views/lineItem";

export const OldLicensesDisplay = ({ count }) => {
  return count > 0 ? (
    <LineItem label="Max 2-6" text={ `${count} license${count > 1 ? 's' : ''} available for upgrade` } />
  ) : null;
};

OldLicensesDisplay.propTypes = {
  count: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./webAdmin/components/institutions/institution/oldLicensesDisplay.js